import {fileQueryKeys} from './fileQueryKeys'
import {createOwnStore} from './ownStore'
import {createShareStore} from './shareStore'
import {FileStore, StorageRoot} from './types'
import {runLimited} from './uploadLimits'

/** The store for a root, acting as the signed-in user (`identityId`). */
export function fileStoreFor(root: StorageRoot, identityId: string): FileStore {
  switch (root.kind) {
    case 'own':
      return createOwnStore(identityId)
    case 'share':
      // Through the sharing API: the caller's own credentials never reach another person's space.
      return createShareStore(root)
  }
}

/**
 * A folder listing's query key and fetcher, built from the same inputs so the cache entry always
 * holds what the key names.
 */
export function folderListQuery(root: StorageRoot, identityId: string, folder: string) {
  return {
    queryKey: fileQueryKeys.list(root, identityId, folder),
    queryFn: () => fileStoreFor(root, identityId).list(folder),
  }
}

/**
 * Uploads a folder picked with `webkitdirectory` into the folder at `folderPath` (breadcrumb form),
 * a few files at a time (runLimited).
 */
export function uploadFolder(store: FileStore, folderContent: any, folderPath: string[]) {
  const files = Array.from(folderContent)
  const path = folderPath.slice(1, folderPath.length).join('/')
  return runLimited(
    files.map((file: any) => () => {
      const fullPath = path === '' ? `${file.webkitRelativePath}` : `${path}/${file.webkitRelativePath}`
      return store.upload(fullPath, file)
    })
  )
}
